import { FormGroup, Input } from '@southfields-digital/mpxlive-components';
import styles from './RundownMosForm.module.scss';

const MOS_PREFIX = 'mos_';
const MOS_PREFIX_REGEX = /^mos_/;

interface IRundownMosFormProps {
  externalReference: Rundown['externalReference'];
  handleUpdate: (newExternalReference: Rundown['externalReference']) => void;
}

export default function RundownMosForm({ externalReference, handleUpdate }: IRundownMosFormProps) {
  const mosId = externalReference?.replace(MOS_PREFIX_REGEX, '');

  const handleMosIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.currentTarget.value;

    handleUpdate(newValue?.length ? `${MOS_PREFIX}${newValue}` : null);
  };

  return (
    <div className={styles.RundownMosForm}>
      <FormGroup label="MOS ID" htmlFor="mosid">
        <Input id="mosid" value={mosId} onChange={handleMosIdChange} />
      </FormGroup>
    </div>
  );
}
